import React from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import styled from 'styled-components';

// Context
import { RuleEditorContext } from '../context';

// Hooks
import { useCriteriaStoreMovePredicateToRoot } from '../../../../../../state/criteria/hooks/useCriteriaStoreMovePredicateToRoot';
import { useCriteriaStorePredicateUuidsWithoutParent } from '../../../../../../state/criteria/hooks/useCriteriaStorePredicateUuidsWithoutParent';

const DropZone = styled.div`
    width: 100%;
    display: flex;
    height: 4rem;
`;

export const PredicateRootDropZone = () => {
    const { setEdited } = React.useContext(RuleEditorContext);
    const movePredicateToRoot = useCriteriaStoreMovePredicateToRoot();
    const nonRootLevelPredicateUuids = useCriteriaStorePredicateUuidsWithoutParent();

    const handleDrop = React.useCallback(
        (droppedUuid) => {
            setEdited(true);
            movePredicateToRoot({
                predicateUuid: droppedUuid,
                predicateGroupUuid: undefined
            });
            document.body.focus();
        },
        [setEdited, movePredicateToRoot]
    );
    const [{ isOver }, drop] = useDrop(
        () => ({
            accept: nonRootLevelPredicateUuids,
            drop(_item, monitor) {
                if (monitor.didDrop()) return;
                handleDrop(monitor.getItemType());

                return undefined;
            },
            collect: (monitor) => ({
                isOver: monitor.isOver({ shallow: true }),
                canDrop: monitor.canDrop(),
                draggingColor: monitor.getItemType()
            })
        }),
        [handleDrop, nonRootLevelPredicateUuids]
    );
    const background = isOver ? '#e7f6ff' : 'transparent';

    return <DropZone ref={drop} role="TargetBox" style={{ background }}></DropZone>;
};

export default PredicateRootDropZone;

PredicateRootDropZone.propTypes = {
    uuid: PropTypes.string,
    nestedLevel: PropTypes.number
};
